<template>
  <span v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card data-testid="debts-page">
      <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
        <v-spacer></v-spacer>
        <v-text-field v-model="search" data-testid="debts-search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
          hide-details></v-text-field>
        <v-spacer></v-spacer>
        <v-btn data-testid="new-debt-btn" small color="success" class="ml-2" @click="
          (newDebtDialog = true),
          (debt = {
            sum: null,
            state: 'Создан',
            description: null,
            group: 'Аренда',
            client_id: null,
            booking_id: null,
          }),
          (bookings = []),
          (search_booking = null)
          ">{{ $t("debts.new") }}</v-btn>
        <v-btn icon
          :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/${$root.$i18n.locale}/categories/4/guides/15`"
          target="_blank">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- Сортировка по умолчанию задаётся ТОЛЬКО через tableOptions, без
           :sort-by / :sort-desc. Литерал массива в пропе создаётся заново на
           каждую перерисовку родителя, а VData сравнивает пропы sortBy/sortDesc
           по ссылке — watcher срабатывал на каждый рендер и возвращал сортировку
           к created_at desc. Клик по «Сумме» давал три запроса за 21 мс
           (sum/asc → created_at/asc → created_at/desc), выигрывал последний. -->
      <v-data-table :headers="headers" :items="debts" :loading="isLoading"
        :loading-text="$t('custom.loading_table')" :server-items-length="total" :options.sync="tableOptions"
        :page.sync="page" :items-per-page="per_page"
        mobile-breakpoint="100" :class="!isMobile ? '' : 'is-mobile'"
        :footer-props="tableFooterProps([20, 50, 100], `{0} ${$t('custom.of')} ${total}`)">
        <template slot="item" slot-scope="props">
          <tr>
            <td class="text-center">{{ props.item.id }}</td>
            <td class="text-center" nowrap>
              <v-icon class="green--text mr-2" v-if="props.item.state != 'Оплачен'" @click="paymentStart(props.item)">
                mdi-cash-multiple
              </v-icon>
              <v-icon class="mr-2" @click="editDebt(props.item.id)">
                mdi-pencil-outline
              </v-icon>
              <v-icon :data-testid="`delete-debt-${props.item.id}`" @click="deleteItem(props.item)" v-if="checkAdmin()">
                mdi-delete-forever
              </v-icon>
            </td>
            <td class="text-center">
              {{ formatCreatedAt(props.item.created_at) }}
            </td>
            <td class="text-center" :style="user_role == 'guest' || user_role == 'partner' ? 'display: none;' : ''">
              <router-link :to="{ path: `/clients/${props.item.client_id}` }">
                {{ props.item.client_name }}
              </router-link>
            </td>
            <td class="text-center">
              <router-link :to="{ path: `/bookings/${props.item.booking_id}` }">{{ props.item.booking_id }}</router-link>
            </td>
            <td class="text-center">{{ translateGroup(props.item.group) }}</td>
            <td class="text-center">{{ props.item.description }}</td>
            <td class="text-center">{{ props.item.sum }}</td>
            <td class="text-center">{{ props.item.paid }}</td>
            <!-- Состояние -->
            <td class="text-center">
              <v-menu absolute offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn :color="stateColor(props.item.state)" small block v-bind="attrs" v-on="on">
                    {{ translateState(props.item.state) }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link v-for="(state, index) in debts_state" :key="index"
                    @click="updateState(props.item.id, state.value)">
                    <v-list-item-title>
                      {{ state.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <!-- Пустая выдача поиска рисуется здесь, а не слотом no-results: тот
             живёт только при клиентской фильтрации (:search), а с серверной
             Vuetify всегда идёт в ветку no-data и no-results не отрисует
             никогда — см. VDataIterator#genEmpty. -->
        <template slot="no-data">
          <v-alert v-if="search" :value="true" color="error" icon="mdi-alert">
            {{ $t("tables.no_search_result", { msg: search }) }}
          </v-alert>
          <span v-else>{{ $t("custom.no_data_in_table") }}</span>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="newDebtDialog" :retain-focus="false" persistent max-width="1000px">
      <v-card data-testid="new-debt-dialog">
        <v-card-title>
          <span class="headline">{{ $t("debts.create") }}</span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="2">
              <v-row align="center">
                <v-col auto>
                  <v-text-field v-model.number="debt.sum" data-testid="new-debt-sum" :label="$t('custom.amount')"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete v-model="debt.group" :items="debts_groups" item-text="text" item-value="value"
                :label="$t('custom.select_group')"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <!-- Автокомплит, а не свободный ввод номера: скоуп поиска
                   (search_booking → company_id = employee_in_company) совпадает
                   со скоупом гарда ensure_params_in_company!, поэтому предложить
                   бронь, которую сервер потом отвергнет, физически нельзя.
                   Свободный ввод давал 404 на любой опечатке, а оператор видел
                   лишь «Ошибка при обновлении долга!» без указания поля. -->
              <v-autocomplete v-model="debt.booking_id" item-text="fullname" item-value="id"
                :loading="isLoadingBookings" :search-input.sync="search_booking" clearable flat
                hide-no-data hide-details :label="$t('bookings.number_booking')" :items="bookings">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete v-model="debt.client_id" item-text="fullname" item-value="id" :loading="isLoadingClients"
                :search-input.sync="search_client" clearable flat hide-no-data hide-details
                :label="$t('bookings.select_client')" :items="clients">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea v-model="debt.description" data-testid="new-debt-description" rows="1" :label="$t('custom.description')"
                :placeholder="$t('debts.description_placeholder')"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="newDebtDialog = false">{{ $t("custom.close") }}</v-btn>
          <v-btn data-testid="new-debt-save" color="success" @click="submit()">{{ $t("custom.save") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" :retain-focus="false" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("custom.editing") }}</span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field v-model.number="debt.sum" :label="$t('custom.amount')"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete v-model="debt.group" :items="debts_groups" item-text="text" item-value="value"
                :label="$t('custom.select_group')"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <!-- Автокомплит, а не свободный ввод номера: скоуп поиска
                   (search_booking → company_id = employee_in_company) совпадает
                   со скоупом гарда ensure_params_in_company!, поэтому предложить
                   бронь, которую сервер потом отвергнет, физически нельзя.
                   Свободный ввод давал 404 на любой опечатке, а оператор видел
                   лишь «Ошибка при обновлении долга!» без указания поля. -->
              <v-autocomplete v-model="debt.booking_id" item-text="fullname" item-value="id"
                :loading="isLoadingBookings" :search-input.sync="search_booking" clearable flat
                hide-no-data hide-details :label="$t('bookings.number_booking')" :items="bookings">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete v-model="debt.client_id" item-text="fullname" item-value="id" :loading="isLoadingClients"
                :search-input.sync="search_client" clearable flat hide-no-data hide-details
                :label="$t('bookings.select_client')" :items="clients">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea v-model="debt.description" rows="1" :label="$t('custom.description')"
                :placeholder="$t('debts.description_placeholder')"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="updateDebt()">{{ $t("custom.save") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="paymentDialog" :retain-focus="false" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="12" class="d-flex align-center">
              <span class="headline">{{ $t("debts.pay") }}</span>
              <v-icon class="ml-2 green--text" @click="savePayment()">
                mdi-content-save-all-outline
              </v-icon>
              <v-spacer></v-spacer>
              <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="
                (paymentDialog = false),
                (paymentData = { sum: null, type: null, state: null })
                ">
                mdi-close
              </v-icon>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row align="center">
                <v-col auto>
                  <v-text-field v-model.number="paymentData.sum" :label="$t('bookings.get_payment')" dense
                    :messages="messageInBaseCurrency(paymentData.sum, paymentData.currency_id)"></v-text-field>
                </v-col>
                <v-col auto v-if="company && company.multicurrency_cashboxes">
                  <v-select v-model="paymentData.company_cashbox" :items="active_company_cashboxes"
                    :item-text="item => item.name" :return-object="true"
                    @change="paymentData.currency_id = paymentData.company_cashbox.currency_id, paymentData.company_cashbox_id = paymentData.company_cashbox.id"
                    :label="$t('companies.currency')" dense></v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-col cols="12" class="d-flex align-center justify-space-between">
                  <v-checkbox v-if="company && company.cash_payment" v-model="paymentData.type" color="success"
                    value="Наличные" :disabled="paymentData.type == 'Терминал' ||
                      paymentData.type == 'На карту' ||
                      paymentData.type == 'Р/с' ||
                      paymentData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentData.type == 'Терминал' ||
                      paymentData.type == 'На карту' ||
                      paymentData.type == 'Р/с' ||
                      paymentData.type == 'Баланс клиента'
                      ? 'opacity: 0.4;'
                      : ''
                      ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="success" v-tooltip="{
                        content: $t('tooltips.cash_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-cash
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.cashless_payment" v-model="paymentData.type" color="warning"
                    value="Терминал" :disabled="paymentData.type == 'Наличные' ||
                      paymentData.type == 'На карту' ||
                      paymentData.type == 'Р/с' ||
                      paymentData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentData.type == 'Наличные' ||
                      paymentData.type == 'На карту' ||
                      paymentData.type == 'Р/с' ||
                      paymentData.type == 'Баланс клиента'
                      ? 'opacity: 0.4;'
                      : ''
                      ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                        content: $t('tooltips.terminal_count'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-contactless-payment-circle-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.card_to_card_payment" v-model="paymentData.type" color="info"
                    value="На карту" :disabled="paymentData.type == 'Наличные' ||
                      paymentData.type == 'Терминал' ||
                      paymentData.type == 'Р/с' ||
                      paymentData.type == 'Баланс клиента'
                      " class="mt-0 mr-0" dense hide-details :style="paymentData.type == 'Наличные' ||
                      paymentData.type == 'Терминал' ||
                      paymentData.type == 'Р/с' ||
                      paymentData.type == 'Баланс клиента'
                      ? 'opacity: 0.4;'
                      : ''
                      ">
                    <template v-slot:label>
                      <v-icon class="text-center mr-2" color="info" v-tooltip="{
                        content: $t('money.card_to_card'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                        delay: {
                          show: 500,
                          hide: 500,
                        },
                      }">
                        mdi-credit-card-check-outline
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.entity_payment" v-model="paymentData.type" color="secondary"
                    class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="paymentData.type == 'Наличные' ||
                      paymentData.type == 'Терминал' ||
                      paymentData.type == 'На карту' ||
                      paymentData.type == 'Баланс клиента'
                      " :style="paymentData.type == 'Наличные' ||
                        paymentData.type == 'Терминал' ||
                        paymentData.type == 'На карту' ||
                        paymentData.type == 'Баланс клиента'
                        ? 'opacity: 0.4;'
                        : ''
                        " v-tooltip="{
                          content: $t('tooltips.entity_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                    <template v-slot:label>
                      <v-icon class="text-center" color="secondary">
                        mdi-bank
                      </v-icon>
                    </template>
                  </v-checkbox>
                  <v-checkbox v-if="company && company.client_payment" v-model="paymentData.type" color="error"
                    class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="paymentData.type == 'Наличные' ||
                      paymentData.type == 'Терминал' ||
                      paymentData.type == 'На карту' ||
                      paymentData.type == 'Р/с'
                      " :style="paymentData.type == 'Наличные' ||
                        paymentData.type == 'Терминал' ||
                        paymentData.type == 'На карту' ||
                        paymentData.type == 'Р/с'
                        ? 'opacity: 0.4;'
                        : ''
                        " v-tooltip="{
                          content: $t('money.client_balance'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                    <template v-slot:label>
                      <v-icon class="text-center" color="error">
                        mdi-account-arrow-right
                      </v-icon>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" v-if="showSelectWorkerCashbox && worker_accounts && worker_accounts.length > 0">
              <v-select v-model="worker_account_id"
                :item-text="item => `${item.company_cashbox ? item.company_cashbox.name : null} ${item.currency ? item.currency.code : null} ${item.cash}`"
                item-value="id" :items="worker_accounts" :label="$t('companies.select_worker_cashbox')" hide-no-data
                hide-details></v-select>
            </v-col>
            <v-col cols="12" class="mt-3 text-center align-center">
              <v-select v-model="paymentData.state" clearable :items="debts_state" item-text="text" item-value="value"
                :label="$t('bookings.select_state')"></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="
            (paymentDialog = false),
            (paymentData = { sum: null, type: null, state: null })
            ">{{ $t("custom.close") }}</v-btn>
          <v-btn color="success" @click="savePayment()">{{ $t("custom.save") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
import { translateDebtState as translateDebtStateText } from "@/utils/localeInfra";
export default {
  data() {
    return {
      debts: [],
      debt: {
        sum: null,
        state: "Создан",
        description: null,
        group: "Аренда",
        client_id: null,
        booking_id: null,
        company_cashbox: null,
        currency_id: null,
        company_cashbox_id: null,
      },
      debts_groups: [
        { text: this.$t("add_services.rent"), value: "Аренда" },
        { text: this.$t("add_services.fines"), value: "Штрафы" },
        { text: this.$t("add_services.damages"), value: "Повреждения" },
        { text: this.$t("add_services.others"), value: "Другое" },
      ],
      debts_state: [
        { text: this.$t("debts_state.created"), value: "Создан" },
        { text: this.$t("debts_state.notify"), value: "Оповещён" },
        // { text: this.$t("debts_state.paid"), value: "Оплачен" },
        { text: this.$t("debts_state.refund"), value: "Возмещён" },
        { text: this.$t("debts_state.remind"), value: "Напомнить" },
        { text: this.$t("debts_state.don_paid"), value: "Не оплачен" },
      ],
      headers: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.client"), value: "client_id", align: "center" },
        {
          text: this.$t("bookings.booking"),
          value: "booking_id",
          align: "center",
        },
        { text: this.$t("custom.group"), value: "group", align: "center" },
        {
          text: this.$t("custom.description"),
          value: "description",
          align: "center",
        },
        { text: this.$t("custom.amount"), value: "sum", align: "center" },
        { text: this.$t("bookings.paid"), value: "paid", align: "center" },
        { text: this.$t("custom.state"), value: "state", align: "center" },
      ],
      paymentData: {
        sum: null,
        type: null,
        state: "Не оплачен",
        group: null,
        debt_id: null,
        company_cashbox: null,
        currency_id: null,
        company_cashbox_id: null,
      },
      worker_account_id: null,
      showSelectWorkerCashbox: false,
      clients: [],
      client: null,
      isLoadingClients: false,
      showClientSearch: false,
      search_client: null,
      // Брони для автокомплита номера в диалогах долга. Приезжают из
      // /api/v1/debts/bookings_for_select — поиск по БД (не Meili), 10 строк,
      // скоуп тот же, что у гарда сохранения, и живёт он в том же контроллере.
      bookings: [],
      isLoadingBookings: false,
      search_booking: null,
      // ТРЕТИЙ таймер дебаунса в этом файле, и это намеренно: timeout занят
      // поиском клиента в диалоге, searchTimeout — поиском по таблице. На одном
      // таймере они гасят друг друга молча (поле показывает новый текст, данные
      // остаются старыми) — этой граблей файл уже наступал.
      bookingSearchTimeout: null,
      // Порядковый номер запроса: дебаунс отменяет только неотправленный таймер,
      // а улетевший ответ на медленной сети приходит последним и перетирает
      // свежий список — ошибки при этом никакой, просто не те брони.
      bookingsRequestSeq: 0,
      search: null,
      paymentDialog: false,
      // Серверная пагинация: страница, размер, сортировка и поиск уезжают в
      // all_debts_v2, таблица больше ничего не фильтрует у себя. Раньше сюда
      // грузились все долги компании за всю историю — на крупных клиентах это
      // 550 записей и 1667 SQL-запросов на один заход.
      page: 1,
      per_page: 20,
      sort_by: "created_at",
      direction: "desc",
      // Единственный источник сортировки по умолчанию: пропы :sort-by/:sort-desc
      // на таблице стоять НЕ должны — см. комментарий у v-data-table.
      tableOptions: { sortBy: ["created_at"], sortDesc: [true] },
      total: 0,
      // Свой таймер, а НЕ общий this.timeout: тот занят дебаунсом поиска клиента
      // в диалоге долга. На одном поле они гасят друг друга — набор в поиске
      // таблицы отменял загрузку клиентов и наоборот, причём молча: поле
      // показывает новый текст, данные остаются старыми.
      searchTimeout: null,
      // Порядковый номер запроса. Дебаунс отменяет только неотправленный таймер,
      // а уже улетевший запрос — нет: на медленной сети ответ старого запроса
      // приходит последним и перетирает свежий. Ошибки при этом никакой, просто
      // не те строки, поэтому ловится только счётчиком.
      debtsRequestSeq: 0,
      editDialog: false,
      newDebtDialog: false,
      timeout: null,
      isMobile: false,
      isLoading: true,
      error: "",
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    let self = this;
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      // Первую загрузку тянет watcher tableOptions — v-data-table отдаёт options
      // при монтировании. Звать getDataFromApi ещё и отсюда значит грузить дважды
      // (так же устроен экран штрафов). Поиск из маршрута ставим здесь: он уезжает
      // на сервер параметром, и его собственный watcher сделает перезапрос.
      if (this.$route.params != {} && this.$route.params.query) {
        this.search = this.$route.params.query;
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  watch: {
    tableOptions(pagination) {
      this.page = pagination.page;
      this.per_page = pagination.itemsPerPage;
      this.sort_by = pagination.sortBy[0] ? pagination.sortBy[0] : "created_at";
      this.direction = pagination.sortDesc[0] ? "desc" : "asc";
      this.getDataFromApi();
    },
    search() {
      if (this.search == "") {
        this.search = null;
      }
      let self = this;
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        // Страница сбрасывается ВНУТРИ дебаунса и только если она не первая:
        // присваивание page меняет проп :page.sync, VData эмитит update:options,
        // и watcher tableOptions делает запрос сам. Снаружи это давало два
        // одинаковых запроса на каждый набранный символ.
        if (self.page !== 1) {
          self.page = 1;
        } else {
          self.getDataFromApi();
        }
      }, 300);
    },
    search_booking() {
      if (this.search_booking === "" || this.search_booking === " ") {
        this.search_booking = null;
        return;
      }
      // Уже выбранная бронь приезжает сюда своей же подписью — не искать по ней
      // заново, иначе выбор мигает и список перезапрашивается на каждый клик.
      if (this.bookings.some((booking) => booking.fullname === this.search_booking)) return;

      let self = this;
      if (this.bookingSearchTimeout) clearTimeout(this.bookingSearchTimeout);
      this.bookingSearchTimeout = setTimeout(() => {
        self.loadBookings();
      }, 200);
    },
    search_client(val) {
      // if (this.debt && this.debt.client_id) {
      //   return;
      // }
      if (this.search_client == "" || this.search_client == " ") {
        this.search_client = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClients();
          }, 200); // delay
        }
        debounce();
      }
    },
  },
  computed: {
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id) {
            cashboxes.push(cashbox);
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    exchange_rates() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.exchange_rates) {
        return this.$store.getters.getCompany.company.exchange_rates;
      } else {
        return [];
      }
    },
    worker_accounts() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.currency_accounts;
      } else {
        return [];
      }
    },
  },
  methods: {
    getDataFromApi() {
      const seq = ++this.debtsRequestSeq;
      this.isLoading = true;
      this.axios
        .post(
          "/api/v1/all_debts_v2",
          {
            page: this.page,
            per_page: this.per_page,
            sort_by: this.sort_by,
            direction: this.direction,
            search: this.search,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          // Ответ обогнавшего себя запроса выбрасываем: он относится к другой
          // странице, сортировке или строке поиска.
          if (seq !== this.debtsRequestSeq) return;

          this.debts = response.data.debts;
          this.total = response.data.total_debts;

          // Удалили последнюю строку последней страницы — сервер отдаёт пустую
          // выдачу, а Vuetify при серверной пагинации страницу НЕ кламповит
          // (VData#updateOptions клампит только при server-items-length < 0).
          // Без этого пользователь остаётся на несуществующей странице с
          // «нет данных» и уходит с неё только кнопкой «назад».
          // Присваивание page само дёрнет watcher tableOptions — он и перезапросит.
          const lastPage = Math.max(1, Math.ceil(this.total / this.per_page));
          if (this.total > 0 && this.page > lastPage) {
            this.page = lastPage;
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.debts_load"));
          console.log(error);
        })
        .finally(() => {
          if (seq === this.debtsRequestSeq) this.isLoading = false;
        });
    },
    submit() {
      if (this.isStaff) {
        let debt = this.debt;
        let self = this;
        if (debt.sum && debt.client_id && debt.group) {
          this.isLoading = true;
          this.axios
            .post(
              "/api/v1/debts",
              {
                debts: {
                  sum: debt.sum,
                  state: debt.state,
                  group: debt.group,
                  description: debt.description,
                  client_id: debt.client_id,
                  booking_id: debt.booking_id,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              // Перезапрос, а не push в массив: при серверной пагинации новый
              // долг может не принадлежать текущей странице, и total на клиенте
              // разъедется с настоящим.
              this.getDataFromApi();
              this.newDebtDialog = false;

              this.$notify(this.$t("debts.added_title"), this.$t("debts.added_text"), "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.add_debt"));
              // Не в finally: на успехе индикатор снимает getDataFromApi, когда
              // перезапрос действительно закончится. Общий finally гасил его
              // сразу после then — таблица показывала старые строки без загрузки.
              this.isLoading = false;
            });
        } else {
          this.$notify(this.$t("errors.all_fields_title"), this.$t("errors.add_debt_fields"), "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    editDebt(id) {
      this.debt = this.debts.find((debt) => debt.id == id);
      // v-autocomplete показывает подпись только для значения, которое есть в
      // items. В строке долга лежит один booking_id без деталей брони, поэтому
      // подставляем минимальную запись — иначе поле выглядит ПУСТЫМ при
      // привязанной брони, и оператор решит, что бронь отвязалась.
      this.bookings = this.debt.booking_id
        ? [ { id: this.debt.booking_id, fullname: `№${this.debt.booking_id}` } ]
        : [];
      this.search_booking = null;
      this.editDialog = true;
      // Пустой поиск отдаёт 10 последних броней — список не пустует до первого
      // набранного символа. Привязанная бронь остаётся в items: loadBookings
      // дописывает её к ответу, если сервер её не вернул.
      this.loadBookings();
    },
    updateDebt() {
      if (this.isStaff) {
        let debt = this.debt;
        let self = this;
        if (debt.sum && debt.client_id && debt.group) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/debts/${debt.id}`,
              {
                debts: {
                  sum: debt.sum,
                  state: debt.state,
                  group: debt.group,
                  description: debt.description,
                  client_id: debt.client_id,
                  booking_id: debt.booking_id,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.debts.findIndex(
                (element) => element.id === debt.id
              );
              this.debts.splice(foundIndex, 1, debt);
              this.editDialog = false;
              this.$notify(this.$t("debts.added_title"), this.$t("debts.update_text"), "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.select_state_debt"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), this.$t("errors.add_debt_fields"), "warning", 4000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    paymentStart(debt) {
      this.paymentData = {
        sum: debt.sum,
        type: null,
        group: debt.group,
        state: "Не оплачен",
        debt_id: debt.id,
        company_cashbox: null,
        currency_id: null,
        company_cashbox_id: null,
      };
      let default_cashbox = this.active_company_cashboxes && this.active_company_cashboxes[0] && this.active_company_cashboxes[0].currency_id ? this.active_company_cashboxes[0] : null
      this.paymentData.company_cashbox = default_cashbox;
      this.paymentData.currency_id = default_cashbox.currency_id;
      this.paymentData.company_cashbox_id = default_cashbox.id;
      this.paymentDialog = true;
    },
    savePayment() {
      if (this.isStaff) {
        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && this.paymentData.type == "Наличные") {
          // проверяем что у пользователя есть выбранный счёт
          let worker_accounts_cashboxes_ids = this.worker_accounts.map(
            (account) => account.company_cashbox_id
          );
          // получаем все company_cashbox_id из наличного платежа
          let cash_payments_cashbox_ids = [this.paymentData.company_cashbox_id];
          // проверяем, есть ли хотя бы один company_cashbox_id из наличных платежей в worker_accounts_cashboxes_ids
          let has_matching_cashbox = cash_payments_cashbox_ids.some(cashbox_id =>
            worker_accounts_cashboxes_ids.includes(cashbox_id)
          );
          // проверяем есть ли в кассах пользователя касса с такой валютой
          let worker_cashboxes_currency_ids = this.worker_accounts.map((account) => account.currency_id);
          let cash_payments_currency_ids = [this.paymentData.currency_id];
          let has_matching_worker_cashbox_currency = cash_payments_currency_ids.some(cashbox_id =>
            worker_cashboxes_currency_ids.includes(cashbox_id)
          );
          if (has_matching_worker_cashbox_currency) {
            console.log("exists worker_cashbox_currency, select first on server")
          } else {
            console.log("not exists worker_cashbox_currency")
            this.$notify(this.$t("errors.not_exists_worker_currency_account"), "", "warning", 5000);
            return;
          }
        }
        if (this.company.multicurrency_cashboxes && this.company.multicurrency_cashboxes == true && this.paymentData.type == "Баланс клиента") {
          // Проверяем если в self.departure_payments есть платеж наличными
          if (this.paymentData.currency_id != this.base_currency_id) {
            this.$notify(this.$t("errors.client_payments_in_non_base_currency"), "", "error", 4000);
            return;
          }
        }
        this.isLoading = true;
        let self = this;
        if (this.paymentData.sum && this.paymentData.type && this.paymentData.company_cashbox_id) {
          this.axios
            .post(
              `/api/v1/debt_payment`,
              {
                sum: this.paymentData.sum,
                type: this.paymentData.type,
                state: this.paymentData.state,
                group: this.paymentData.group,
                debt_id: this.paymentData.debt_id,
                company_cashbox_id: this.paymentData.company_cashbox_id,
                currency_id: this.paymentData.currency_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              let foundIndex = this.debts.findIndex(
                (element) => element.id === self.paymentData.debt_id
              );
              this.debts[foundIndex].state = this.paymentData.state;

              this.paymentDialog = false;
              this.$notify(this.$t("debts.debt_paid_title"), this.$t("debts.debt_paid_text"), "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.pay_debt"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.isLoading = false;
          this.$notify(this.$t("common.no_data"), this.$t("errors.pay_debt_fields"), "warning", 3000);
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateState(id, state) {
      if (this.isStaff) {
        this.isLoading = true;
        let self = this;
        this.axios
          .patch(
            `/api/v1/debts/${id}`,
            {
              debts: {
                state: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.debts.findIndex(
              (element) => element.id === id
            );
            let debt = this.debts[foundIndex];
            debt.state = state;
            this.debts.splice(foundIndex, 1, debt);
            this.$notify(this.$t("debts.updated_debt"), this.$t("debts.debt_paid_text"), "success", 3000);
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.edit_debt"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Подпись брони в списке: номер плюс то, по чему оператор её узнаёт.
    // Номер первым — поле называется «номер брони», и поиск по нему основной.
    bookingLabel(booking) {
      const who = [booking.last_name, booking.first_name].filter(Boolean).join(" ");
      const car = [booking.car_name, booking.car_code].filter(Boolean).join(" ");
      return [`№${booking.id}`, who, car, booking.start_date].filter(Boolean).join(" · ");
    },
    loadBookings() {
      // Vuetify кладёт в search-input подпись ВЫБРАННОГО элемента, и она уезжала
      // на сервер как поисковый запрос: «№643356» не совпадает ни с одной
      // колонкой, выдача пустела, и в списке оставалась одна привязанная бронь.
      // Нормализуем здесь, а не в watcher'е: там это зависит от порядка событий
      // (Vuetify выставляет подпись после того, как запрос уже улетел).
      const isSelectedLabel = this.bookings.some(
        (booking) => booking.fullname === this.search_booking
      );
      const term = isSelectedLabel ? null : this.search_booking;

      const seq = ++this.bookingsRequestSeq;
      this.isLoadingBookings = true;
      this.axios
        .post(
          "/api/v1/debts/bookings_for_select",
          { search: term },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          if (seq !== this.bookingsRequestSeq) return;

          const found = Array.isArray(response.data) ? response.data : [];
          found.forEach((booking) => {
            booking.fullname = this.bookingLabel(booking);
          });
          // Привязанная бронь могла не попасть в выдачу (её нет ни в 10 последних,
          // ни в результатах поиска). Без этого подпись выбранного значения
          // пропадает, и поле выглядит пустым при непустом booking_id.
          const linked = this.debt && this.debt.booking_id;
          if (linked && !found.some((booking) => booking.id === linked)) {
            found.unshift({ id: linked, fullname: `№${linked}` });
          }
          this.bookings = found;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.bookings_load"));
        })
        .finally(() => {
          if (seq === this.bookingsRequestSeq) this.isLoadingBookings = false;
        });
    },
    loadClients() {
      this.isLoadingClients = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.search_client,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.clients = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                client.lastname +
                " " +
                client.name +
                " " +
                client.middlename +
                " " +
                (client.phone
                  ? client.phone.slice(client.phone.length - 4)
                  : "");
            } else {
              client["fullname"] =
                client.entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                (client.entity_phone
                  ? client.entity_phone.slice(client.entity_phone.length - 4)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.isLoadingClients = false;
          this.setError(error, this.$t("errors.clients_load"));
        })
        .finally(() => (this.isLoadingClients = false));
    },
    translateGroup(group) {
      let group_text = "";
      if (group == "Аренда") {
        group_text = this.$t("add_services.rent");
      }
      if (group == "Штрафы") {
        group_text = this.$t("add_services.fines");
      }
      if (group == "Повреждения") {
        group_text = this.$t("add_services.damages");
      }
      if (group == "Другое") {
        group_text = this.$t("add_services.others");
      }
      return group_text;
    },
    translateState(state) {
      return translateDebtStateText(this.$t.bind(this), state);
    },
    stateColor(state) {
      if (state == "Оповещён") {
        return "warning";
      }
      if (state == "Напомнить") {
        return "secondary";
      }
      if (state == "Оплачен") {
        return "success";
      }
      if (state == "Возмещён") {
        return "success";
      }
      if (state == "Не оплачен") {
        return "red";
      }
    },
    deleteItem(debt) {
      if (this.isStaff) {
        this.$confirm({
          title: this.$t("custom.you_sure_title"),
          text: this.$t("custom.you_sure_text"),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t("custom.you_sure_yes"),
          cancelButtonText: this.$t("custom.you_sure_no"),
        }).then((result) => {
          if (result) {
            this.axios
              .delete(`/api/v1/debts/${debt.id}`, {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              })
              .then((response) => {
                // Перезапрос, а не splice: удаление меняет total и состав страницы.
                this.getDataFromApi();
                this.$notify(this.$t("custom.deleted"), this.$t("debts.delete_debt_text"), "success", 3000);
              })
              .catch((error) => {
                this.setError(error, this.$t("errors.delete_debt"));
                // См. submit: на успехе индикатор снимает getDataFromApi.
                this.isLoading = false;
              });
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    sumInBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) / parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    sumInNonBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) * parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    messageInBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(this.base_currency_id)}`;
      } else {
        return '';
      }
    },
    messageInNonBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInNonBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(currency_id)}`;
      } else {
        return '';
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    formatCreatedAt(date) {
      return moment.parseZone(date).format("LL");
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
};
</script>
